import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Stack } from '@tekion/tmatter';
import Heading from '../../../atoms/Heading';
var HeaderComponent = function HeaderComponent(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Stack, {
    align: "left"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 1
  }, label)));
};
HeaderComponent.propTypes = {
  label: PropTypes.string.isRequired
};
export default HeaderComponent;